<template>
  <div id="ticketChat">

    <div class="flex-container">
      <div class="header">
        <div class="vo-icon-button">
          <v-btn small fab flat @click="routeRemoveQuery('chat')"><v-icon medium>mdi-close</v-icon></v-btn>  
        </div>
        Ticket Chat
      </div>

      <template v-if="ticket">
        <div class="chat" ref="chat">

          <vo-list ref="chatList" v-if="page.ticketChat.list" :list="page.ticketChat.list" forceBottom fill flip lazy :endState="false" @updated="$forceUpdate()">
            <div slot-scope="item" slot="itemSlot">
              
              <!-- SYSTEM CHAT -->
              <div class="system" v-if="$store.getters.ticketChat(item.item).systemGenerated">
                <div class="body">{{ $store.getters.ticketChat(item.item).body }}</div>
                <div class="date">{{ $store.getters.ticketChat(item.item).created | dateTimeShorthand }}</div>
                <div class="name" v-if="$store.getters.ticketChat(item.item).user">by {{ $store.getters.user($store.getters.ticketChat(item.item).user).fullName }}</div>
                <!-- TODO: Make this only show name for managers -->
              </div>

              <!-- USER CHAT -->
              <div class="message" :class="{me: $store.getters.ticketChat(item.item).user === $store.getters.profile._id}" v-else>
                <vo-avatar class="avatar" :user="$store.getters.user($store.getters.ticketChat(item.item).user)" :size="30"></vo-avatar>
                <div class="message-content">
                  <div class="name">{{ $store.getters.user($store.getters.ticketChat(item.item).user).fullName }}</div>
                  <div class="date">{{ $store.getters.ticketChat(item.item).created | dateTimeShorthand }}</div>
                  <div class="body">{{ $store.getters.ticketChat(item.item).body }}</div>
                </div>
              </div>
              
            </div>
          </vo-list>
        </div>

        <div class="chatbox">
          <div class="inputbox">
    
            <v-text-field ref="inputChat" :disabled="lockout" :loading="lockout" auto-grow no-resize :rows="1" @keypress.prevent.enter="send" multi-line v-model="chatMessage" class="text-field" hide-details placeholder="Type something..."></v-text-field>
          </div>
          <v-btn flat primary class="send" small :disabled="lockout" @click="send">SEND</v-btn>
        </div>
      </template>
      <template v-else>
        <vo-empty-state text="Select a Ticket"></vo-empty-state>
      </template>

    </div>
  </div>
</template>

<script>

  export default {
    
    data () {
      return {
        chatMessage: '',
        lockout: false,
        timeouts: {
          chat: false
        }
      }
    },
    
    props: {
      
      page: {
        required: true,
        type: Object
      }

    },

    methods: {

      send () {
        if (this.lockout) return;
        this.lockout = true;
        
        this.$store.dispatch('createTicketChat', {
          ticket: this.ticket._id,
          property: this.ticket.property,
          comment: {
            body        : this.chatMessage.trim(),
            ticket      : this.ticket._id,
            user        : this.$store.getters.profile._id
          }
        })
        .then(data => {
          AppData.app.pages.tickets.ticketChat.list.addItem(data._id);
          this.chatMessage = '';
          this.lockout = false;
          Toast.show('Message sent.', 'success');
          this.$nextTick( () => {
            this.$refs.chatList.toBottom();
            this.$refs.inputChat.focus();
          });
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.lockout = false;
        });

      },

      initSelected () {
        
        // Check Ticket is Set and not changed
        if (!this.selected) return;
          
        // Reset Ticket Chat
        if (this.page.ticketChat.list) this.page.ticketChat.list.clearList();
        
        if (this.timeouts.chat) clearTimeout(this.timeouts.chat);
        this.timeouts.chat = setTimeout(() => {
  
          // Create Ticket Chat list
          Vue.set(this.page.ticketChat, 'list', new ListModel({
            ...this.page.ticketChat.listParams
          }));
          
          // Set Params - Being watched by List.vue, will load itself
          this.page.ticketChat.list.params = {
            ticket: this.ticket._id,
            property: this.ticket.property
          };

        }, window.cordova ? 800 : 1);
        
      }
    },
    
    computed: {

      ticket () {
        return this.$store.getters.ticket(this.page.selected);
      },

      selected () {
        return this.page.selected;
      }

    },

    watch: {

      'selected' () {
        this.initSelected();
      }      

    },

    created () {
      
      this.initSelected();

      // ticketChatAdded - Add chat to the list and scroll to the bottom
      document.addEventListener('ticketChatCreated', (e) => {
        var comment = e.detail;

        // Return if not this ticket
        if (this.selected !== comment.ticket) return;
        
        this.$nextTick(() => {
          // Scroll List to bottom
          if (this.$refs.chatList) this.$refs.chatList.toBottom();
        });
      });
    }
  }

</script>

<style lang="scss" scoped>

  @import '../css/global.scss';

  #ticketChat {

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $white;

    .flex-container {
      
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;

      display: flex;
      flex-direction: column;
      
      .header {
        width: 100%;
        border-bottom: $borderBlack12;
        background: #fafafa;
        
        @include fontPrimary500;
        @include title();
  
        text-align: center;
        line-height: 48px;
        color: $black54;
  
        .vo-icon-button {
          display: none;
          position: absolute;
          right: 3px;
          top: 0;
          height: 48px;
          width: 48px;
        }
      }
  
      .chat {
        position: relative;
        @include scrollable();
        background: #FFF;
        flex-shrink: 1;
        height: 100%;
        
        .system {
          text-align: center;
          @include fontPrimary400();
          border-top: 1px solid #E0E0E0;// 12% black on white, because the borders can overlap
          border-bottom: 1px solid #E0E0E0;
          padding: 16px;
          margin: 0 auto -1px;
          width: calc(100% - 32px);
  
          &.border-bottom {
            border-bottom: $borderBlack12;
          }
  
          .body {
            color: $black87;
          }
  
          .date {
            color: $black54;
          }
  
          .name {
            color: $black54;
          }
        }
  
        .message {
          position: relative;
          margin: 24px 0 50px;
  
          .avatar {
            position: absolute;
            left: 16px;
            top: 4px;
          }
  
          .message-content {
            position: relative;
            width: calc(100% - 80px);
            margin: 0 0 0 60px;
  
            .name {
              @include fontPrimary500();
              @include textEllipsis();
  
              width: 100%;
              font-size: 16px;
              color: $black87;
            }
  
            .date {
              width: 100%;
  
              @include fontPrimary300();
              @include textEllipsis();
              font-size: 12px;
              color: $black54;
            }
  
            .body {
              margin: 16px 0 0;
              width: 100%;
              @include fontPrimary400();
            }
          }
        
          &.me {
  
            .avatar {
              right: 16px;
              left: auto;
            }
  
            .message-content {
              margin: 0 60px 0 20px;
  
              .name, .date, .body {
                text-align: right;
              }
            }
  
          }
        }
      }
  
      .chatbox {
        flex-grow: 1;
        width: 100%;
        background: #fafafa;
        height: auto;


        .inputbox {
          width: calc(100% - 80px);
          margin: 8px;
          position: relative;
          bottom: 0;

  
          .text-field {
            border-radius: 3px;
            background: #FFF;
            padding: 8px;
          
            &.input-group--multi-line textarea {
              max-height: 76px;
              resize: none;
            }

          }
        }
  
        .send {
          position: absolute;
          bottom: 0;
          right: 0;
          padding: 0;
          cursor: pointer;
          min-width: 0px !important;
          font-size: 14px;
          padding: 8px 4px;
          min-height: 48px;

          @include fontPrimary500();
          @include title();
          color: $primary;
        }
  
        
      }
    }


    @media screen and (max-width: 1480px) {

      .header {

        .vo-icon-button {
          display: block !important;
        }

      }

    }

  }

</style>


// WEBPACK FOOTER //
// src/components/TicketChat.vue